import { request } from '../config.js'

// 初始化
export const getdownloaddetail = (shareLinkId) => {
  return request.get({
    url: `/api/share/download/${shareLinkId}`,
  })
}

// 检验登录信息
export const logouserinfo = () => {
  return request.get({
    url: '/user/checkLogin',
  })
}

// 验证码获取
export const send_codeApi = (shareLinkId, phone) => {
  return request.get({
    url: `/api/share/accessCode/${shareLinkId}/${phone}`,
  })
}

// 验证码校验
export const mactchAccessCode = (shareLinkId, phone) => {
  return request.get({
    url: `/api/share/mactchAccessCode/${shareLinkId}/${phone}`,
  })
}


// 验证码校验   查看下载详情
export const downloadinfophone = (shareLinkId) => {
  return request.get({
    url: `/api/share/download/info/${shareLinkId}`,
  })
}



// 查看下级文件夹详情
export const downloadlistnext = (shareLinkId, folderId) => {
  return request.get({
    url: `/api/share/download/list/${shareLinkId}/${folderId}`,
  })
}



// 下载
export const usershare = (shareLinkId, params) => {
  return request.postjson({
    url: `/api/share/download/${shareLinkId}`,
    data: JSON.stringify(params)
  })
}



// 下载
export const createDownLoadUrl = (params) => {
  return request.postjson({
    url: `/api/createDownLoadUrl`,
    data: JSON.stringify(params)
  })
}
